"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthState = exports.AuthContext = void 0;
var react_1 = __importDefault(require("react"));
exports.AuthContext = react_1.default.createContext({ user: null, token: "", updateToken: function (newtoken) { } });
exports.AuthContext.displayName = "Auth Context";
var useAuthState = function () {
    var _a = react_1.default.useState(""), loginToken = _a[0], setLoginToken = _a[1];
    return [loginToken, setLoginToken];
};
exports.useAuthState = useAuthState;
